__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-workspaces/v1_2_16/";